import { darken, getLuminance, lighten, Theme } from '@mui/material';

/**
 * Tinge um AStatusActionCard com uma cor custom (fora dos 4 tons do componente), seguindo a mesma
 * receita do próprio componente: fundo CLAREADO no tema claro / ESCURECIDO no tema escuro; borda e
 * avatar na cor cheia. Retorna uma função de tema, pra ser usada como elemento de um array de `sx`.
 *
 * Exceção: cores MUITO ESCURAS (ex.: o preto do "Urgente") somem no fundo escuro se forem
 * escurecidas — então, no tema escuro, elas são CLAREADAS (fundo, borda e avatar) pra ficarem
 * visíveis.
 *
 * @param colorHex cor do sistema em hex SEM '#' (ex.: "ff7800").
 */
export const buildColorTintSx = (colorHex: string) => (theme: Theme) => {
    const color = `#${colorHex}`;
    const isDark = theme.palette.mode === 'dark';
    const veryDark = getLuminance(color) < 0.06;

    const backgroundColor = isDark
        ? veryDark
            ? lighten(color, 0.15)
            : darken(color, 0.85)
        : lighten(color, 0.85);

    // No tema escuro, uma cor muito escura vira um cinza médio pra borda/avatar não sumirem.
    const accent = isDark && veryDark ? lighten(color, 0.4) : color;

    return {
        backgroundColor,
        borderColor: accent,
        '& .MuiAvatar-root': { backgroundColor: accent },
    };
};
